import { createMiddleware } from "@tanstack/react-start";

import { requireAuthedPlayerSession } from "#/server/authedSession.server";

export const authedMiddleware = createMiddleware({ type: "function" }).server(async ({ next }) => {
  const session = await requireAuthedPlayerSession();
  return next({ context: session });
});
